import React from 'react';

function App({ children }) {
  return (
    <div className="page">

      {children}

    </div>
  );
}

App.propTypes = {
  children: React.PropTypes.node.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js